import { Skeleton, Stack } from "@mui/material";

const ParagraphSkeleton = ({ rows = 4 }: { rows?: number }) => (
  <Stack sx={{ mb: 4, gap: 1 }}>
    <Skeleton width="10%" />
    <Skeleton width="30%" />
    {Array.from({ length: rows }, (_, i) => (
      <Skeleton key={i} width="100%" />
    ))}
  </Stack>
);

export const TermsAndConditionSkeleton = () => (
  <>
    <ParagraphSkeleton rows={4} />
    <ParagraphSkeleton rows={8} />
    <ParagraphSkeleton rows={8} />
  </>
);
